import React from 'react'

const OverView = () => {
  return (
    <div className='text-green-500'>OverView</div>
  )
}

export default OverView